import React from 'react';
import styles from './Top.module.css';

import { Button } from '@mantine/core';

import IcomButton from '@icons/IcomButton.svg';
import Check from '@icons/Check.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useAuth from '@hooks/useAuth/useAuth';

const Top = ({ updateOrg, form, update, page }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ currentUser }, { setDataUser }] = useAuth();

  const handleSave = async () => {
    const { hasErrors } = form.validate();

    if (!hasErrors) {
      const values = form.getValues()

      if (page === 'profile') {
        const data = await update(values)
  
        setDataUser({ ...currentUser, ...data, username: data.name });
      }
  
      if (page === 'organization') {
        updateOrg(values)
      }
    }
  }

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div className={styles.arrow} onClick={handleBack}>
          <img src={IcomButton} />
        </div>

        <div className={styles.prev}>
          {t('profile.title')}
        </div>
      </div>

      <div className={styles.right}>
        <Button
          leftSection={<img src={Check} />}
          onClick={handleSave}
        >
          {t('save')}
        </Button>
      </div>
    </div>
  )
}

export default Top;
